module.exports = __webpack_public_path__ + "static/media/logo.45795b4d.png";